module.exports = __webpack_public_path__ + "img/footer-patern-right.b4a4f417.png";